module.exports = __webpack_public_path__ + "static/img/Rectangle18.5218010f.png";